import { gql } from '@apollo/client';

export const UpdateGoogleServices = gql`
mutation UpdateGoogleServices($content: contentGoogle!, $idStore: ID!) {
  updateGoogleServices(content: $content, idStore: $idStore) {
    status
  }
}
`;